module.exports = __webpack_public_path__ + "img/arrow-right.4356b5fe.svg";